import { youtubeAds } from '@/config/previewResolutions';
export let GalleryPanelEnum;

(function (GalleryPanelEnum) {
  GalleryPanelEnum[GalleryPanelEnum["TEMPLATES"] = 0] = "TEMPLATES";
  GalleryPanelEnum[GalleryPanelEnum["THEME"] = 1] = "THEME";
  GalleryPanelEnum[GalleryPanelEnum["DATA"] = 2] = "DATA";
  GalleryPanelEnum[GalleryPanelEnum["CHARTS"] = 3] = "CHARTS";
  GalleryPanelEnum[GalleryPanelEnum["UPLOAD"] = 4] = "UPLOAD";
  GalleryPanelEnum[GalleryPanelEnum["SIGNUP"] = 5] = "SIGNUP";
})(GalleryPanelEnum || (GalleryPanelEnum = {}));

export const GALLERY_TEMPLATE_PANEL_ID = GalleryPanelEnum.TEMPLATES;
export const GALLERY_THEME_PANEL_ID = GalleryPanelEnum.THEME;
export const GALLERY_DATA_PANEL_ID = GalleryPanelEnum.DATA;
export const GALLERY_CHARTS_PANEL_ID = GalleryPanelEnum.CHARTS;
export const GALLERY_SIGNUP_PANEL_ID = GalleryPanelEnum.SIGNUP; // Initial Chart Dimensions

export const CHARTS_ASPECT_RATIO = {
  BarChart: youtubeAds.value,
  StackedBarChart: youtubeAds.value,
  LineChart: youtubeAds.value,
  GaugeChart: youtubeAds.value,
  Scatter: youtubeAds.value,
  Bubble: youtubeAds.value
};